module.exports = __webpack_public_path__ + "static/media/Yopen-laranja.b236801a.ico";